import React from "react";
import CustomTypography from "../CustomComponents/CustomTypography/CustomTypography";
import CustomCard from "../CustomComponents/CustomCard/CustomCard";
import CustomCardContent from "../CustomComponents/CustomCardContent/CustomCardContent";
import clsx from "clsx";
import { useStyles } from "../../assets/jss/Dashboard";
import CustomGrid from "../CustomComponents/CustomGrid/CustomGrid";
import CustomCircularProgress from "../CustomComponents/CustomCircularProgress/CustomCircularProgress";
import CustomAccordion from "../CustomComponents/CustomAccordion/CustomAccordion";
import CustomAccordionDetails from "../CustomComponents/CustomAccordion/CustomAccordionDetails";
import CustomAccordionSummary from "../CustomComponents/CustomAccordion/CustomAccordionSummary";
import CustomList from "../CustomComponents/CustomList/CustomList";
import CustomListItem from "../CustomComponents/CustomListItem/CustomListItem";
import CustomListItemText from "../CustomComponents/CustomListItemText/CustomListItemText";
import { CustomExpandMoreIcon } from "../CustomComponents/CustomIcon/CustomIcon";
import { getUserData, getUserRBAC } from "../../services/LocalStorageService";
import { titleCase } from "../../assets/helperFunctions";
import { Link } from "react-router-dom";
import CustomSkeleton from "../CustomComponents/CustomSkeleton/CustomSkeleton";
import trackEvents from "../../assets/appInsightsEvents";
import ErrorAlert from "../ErrorAlert/ErrorAlert";
import {
    getRiskCategory,
    getRiskCategoryDriver,
} from "../../services/RiskCategory";
import { EntityAccess, RBAC_CODE } from "../../config/app-globals.enum";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

export default function DashboardDriverAtRisk(props:any) {
    const params = useParams();
    const { t } = useTranslation();
    const classes = useStyles();
    const [dense] = React.useState(false);
    const [isApi, setIsApi] = React.useState(false);
    const [isApiFailed, setIsApiFailed] = React.useState(false);
    const [userData] = React.useState(getUserData);
    const [expanded, setExpanded] = React.useState<any>(false);
    const [getRBAC_DriverAtRiskAccordionView] = React.useState(
        getUserRBAC(RBAC_CODE.DRIVER_AT_RISK_ACCORDION_VIEW, props)
    );
    const [getRBAC_DriverAtRiskCardView] = React.useState(
        getUserRBAC(RBAC_CODE.DRIVER_AT_RISK_CARD_VIEW, props)
    );
    const [getRBAC_UserDetailView] = React.useState(getUserRBAC(RBAC_CODE.USER_DETAIL_VIEW, props));
    const handleChange =
        (panel, id, isCatDataAvailable) => (event, isExpanded) => {
            trackEvents("Drivers At Risk", {
                type: panel.substring(5),
                expand: isExpanded,
            }, params);
            setExpanded(isExpanded ? panel : false);
            isExpanded && isCatDataAvailable && getCatData(id);
        };

    //====
    const [statusValue, setStatusValue] = React.useState();
    const [alertMessage, setAlertMessage] = React.useState("");
    const [isAlertOpen, setIsAlertOpen] = React.useState(false);
    const changeApiStatusCodeFunc = (status) => {
        if (status.code && status.code !== 0 && status.code !== 200) {
            setStatusValue(status.code);
            setAlertMessage(
                status.message
                    ? status.message
                    : `${t("SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN_LATER")}`
            );
            setIsAlertOpen(true);
        }
    };
    //====

    const [riskCategoryDriverArray, setRiskCategoryDriverArray] =
        React.useState(null);
    const [catDataApiLoader, setCatDataApiLoader] = React.useState(false);
    const getCatData = (catId) => {
        async function riskCategoryDriver(catId) {
            setCatDataApiLoader(true);
            setIsApi(true);
            const data = await getRiskCategoryDriver(catId, params);
            if (
                data &&
                (data.status.code === 0 ||
                    data.status.code === 200 ||
                    data.status.code === 201) &&
                data.content
            ) {
                setIsApi(false);
                setIsApiFailed(false);
                setRiskCategoryDriverArray(data.content.driverList);
            } else {
                setIsApi(false);
                setIsApiFailed(true);
                changeApiStatusCodeFunc(data.status);
            }
        }
        riskCategoryDriver(catId);
    };

    const [riskCategoryArray, setRiskCategoryArray] = React.useState(null);
    React.useEffect(() => {
        async function riskCategory() {
            setIsApi(true);
            const data = await getRiskCategory(params);
            if (
                data &&
                (data.status.code === 0 ||
                    data.status.code === 200 ||
                    data.status.code === 201) &&
                data.content
            ) {
                setIsApi(false);
                setRiskCategoryArray(data.content);
            } else {
                setIsApi(false);
                changeApiStatusCodeFunc(data.status);
            }
        }
        riskCategory();
    }, []);

    return (
        <>
            <CustomGrid
                container
                spacing={4}
                alignItems="center"
                justifyContent="space-between"
            >
                <CustomGrid item>
                    <CustomTypography
                        component="h1"
                        variant="h5"
                        className={classes.severeEvents}
                    >
                        {getRBAC_DriverAtRiskCardView &&
                            getRBAC_DriverAtRiskCardView.isAccessible === EntityAccess.ALLOWED &&
                            getRBAC_DriverAtRiskCardView.isGroupScope === EntityAccess.ALLOWED
                            ? t("DRIVERS_AT_RISK")
                            : t("AT_RISK_DRIVING_EVENTS")}
                    </CustomTypography>
                </CustomGrid>
                <CustomGrid item>
                    {isApi && (
                        <CustomCircularProgress className={classes.circularProgressSmall} />
                    )}
                </CustomGrid>
            </CustomGrid>
            <CustomCard elevation={0} className={classes.cardContentWrapper}>
                <CustomCardContent
                    className={clsx(classes.cardContent, classes.accordionWrapper)}
                >
                    {riskCategoryArray &&
                        riskCategoryArray.length &&
                        riskCategoryArray.map((cat, index) => {
                            return (
                                <CustomAccordion
                                    key={`${cat.riskId}-${index}-${Math.floor(
                                        Math.random() * 101
                                    )}`}
                                    elevation={0}
                                    expanded={expanded === `panel-${cat.riskId}-${index}`}
                                    onChange={
                                        (getRBAC_DriverAtRiskAccordionView &&
                                        getRBAC_DriverAtRiskAccordionView.isAccessible &&
                                        getRBAC_DriverAtRiskAccordionView.isAccessible === EntityAccess.ALLOWED &&
                                        cat.driverCount > 0 )?
                                        handleChange(
                                            `panel-${cat.riskId}-${index}`,
                                            cat.riskId,
                                            cat.driverCount > 0
                                        ):null
                                    }
                                >
                                    <CustomAccordionSummary
                                        className={clsx(
                                            classes.accordionSummary,
                                            getRBAC_DriverAtRiskAccordionView &&
                                            getRBAC_DriverAtRiskAccordionView.isAccessible &&
                                            getRBAC_DriverAtRiskAccordionView.isAccessible === EntityAccess.ALLOWED &&
                                            classes.accordionSummaryTypeDriver,
                                            getRBAC_DriverAtRiskAccordionView &&
                                            getRBAC_DriverAtRiskAccordionView.isAccessible &&
                                            getRBAC_DriverAtRiskAccordionView.isAccessible === EntityAccess.ALLOWED &&
                                            cat.driverCount === 0 &&
                                            classes.accordionSummaryMarginRight
                                        )}
                                        expandIcon={
                                            getRBAC_DriverAtRiskAccordionView &&
                                                getRBAC_DriverAtRiskAccordionView.isAccessible &&
                                                getRBAC_DriverAtRiskAccordionView.isAccessible === EntityAccess.ALLOWED &&
                                                cat.driverCount > 0 ? <CustomExpandMoreIcon /> : null
                                        }
                                        aria-controls={`panel-${cat.riskId}-${index}-content`}
                                        id={`panel-${cat.riskId}-${index}-header`}
                                    >
                                        <CustomTypography
                                            className={clsx(
                                                classes.heading,
                                                isApi && classes.headingDisabled
                                            )}
                                        >
                                            {t(`RISK_CATEGORY_${cat.riskCode}`)}
                                        </CustomTypography>
                                        <CustomTypography
                                            component="div"
                                            className={classes.secondaryHeading}
                                        >
                                            {cat.driverCount}
                                        </CustomTypography>
                                    </CustomAccordionSummary>
                                    <CustomAccordionDetails className={classes.accordionDetails}>
                                        <CustomList
                                            dense={dense}
                                            className={classes.driverRiskList}
                                        >
                                            {isApi ? (
                                                <CustomListItem className={classes.driverRiskListItem}>
                                                    <CustomListItemText
                                                        className={classes.driverRiskListItemText}
                                                    >
                                                        <CustomCircularProgress
                                                            className={classes.circularProgressSmall}
                                                        />
                                                    </CustomListItemText>
                                                    <CustomListItemText
                                                        className={classes.driverRiskListItemText}
                                                    ></CustomListItemText>
                                                </CustomListItem>
                                            ) : null}
                                            {!isApi && isApiFailed ? (
                                                <CustomListItem className={classes.driverRiskListItem}>
                                                    <CustomListItemText
                                                        className={classes.driverRiskListItemText}
                                                    >
                                                        <CustomSkeleton
                                                            animation="wave"
                                                            width={100}
                                                            height={40}
                                                        />
                                                    </CustomListItemText>
                                                    <CustomListItemText
                                                        className={classes.driverRiskListItemText}
                                                    >
                                                        <CustomSkeleton
                                                            animation="wave"
                                                            width={100}
                                                            height={40}
                                                        />
                                                    </CustomListItemText>
                                                </CustomListItem>
                                            ) : null}
                                            {!isApi &&
                                                riskCategoryDriverArray &&
                                                riskCategoryDriverArray.length > 0
                                                ? riskCategoryDriverArray.map((item, index) => {
                                                    return (
                                                        <CustomListItem
                                                            key={`${item.userId}-${index}`}
                                                            className={classes.driverRiskListItem}
                                                        >
                                                            <CustomListItemText
                                                                className={classes.driverRiskListItemText}
                                                            >
                                                                <div
                                                                    className={
                                                                        classes.driverRiskListItemTextInner
                                                                    }
                                                                >
                                                                    {/* <CustomBox
                                      className={classes.avatarContainer}
                                    >
                                      <CustomAvatar className={classes.avatar}>
                                        {item.userName &&
                                          getInitials(item.userName)}
                                      </CustomAvatar>
                                    </CustomBox> */}
                                                                    {getRBAC_UserDetailView &&
                                                                        getRBAC_UserDetailView.isAccessible &&
                                                                        getRBAC_UserDetailView.isAccessible === EntityAccess.ALLOWED &&
                                                                        ((getRBAC_UserDetailView.isGroupScope &&
                                                                            getRBAC_UserDetailView.isGroupScope ===
                                                                            EntityAccess.ALLOWED) ||
                                                                            item.userId === userData.id) ? (
                                                                        <Link
                                                                            className={classes.driverLink}
                                                                            to={{
                                                                                pathname: `/userdetails/${item.userId}`,
                                                                                state: {
                                                                                    userId: item.userId,
                                                                                    tabValue: 2,
                                                                                    showTab: "Speeding",
                                                                                    sortBy: "SchoolRunSpeeders",
                                                                                },
                                                                            }}
                                                                        >
                                                                            {titleCase(item.userName)}
                                                                        </Link>
                                                                    ) : (
                                                                        <>{titleCase(item.userName)}</>
                                                                    )}
                                                                </div>
                                                            </CustomListItemText>
                                                            <CustomListItemText
                                                                className={classes.driverRiskListItemValue}
                                                                primary={item.message}
                                                            />
                                                        </CustomListItem>
                                                    );
                                                })
                                                : null}
                                            {!isApi &&
                                                (!riskCategoryDriverArray ||
                                                    !riskCategoryDriverArray.length) ? (
                                                <CustomListItem className={classes.driverRiskListItem}>
                                                    <CustomListItemText
                                                        className={classes.driverRiskListItemText}
                                                    >
                                                        <span>{t("NO_RECORDS_FOUND")}.</span>
                                                    </CustomListItemText>
                                                </CustomListItem>
                                            ) : null}
                                        </CustomList>
                                    </CustomAccordionDetails>
                                </CustomAccordion>
                            );
                        })}
                </CustomCardContent>
            </CustomCard>
            <ErrorAlert
                code={statusValue}
                message={alertMessage}
                isOpen={isAlertOpen}
                isClose={(isClose) => setIsAlertOpen(!isClose)}
            />
        </>
    );
}
